import { Alert, Button } from '@mui/material';
import React, { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import useVersion from '../project/useVersion';

const CheckVersion = () => {
  const navigate = useNavigate();
  const [displayAlert, setDisplayAlert] = useState(false);
  const profile = useSelector((state) => state?.login?.profile);
  const { data: backendVersion, _error } = useVersion(profile?._id);

  const frontendVersion = import.meta.env.VITE_PROJECT_VERSION;

  const compareVersions = useCallback((version1, version2) => {
    if (!version1 || !version2) {
      return false;
    }
    const [major1, minor1] = version1.split('.').map(Number);
    const [major2, minor2] = version2.split('.').map(Number);

    if (isNaN(major1) || isNaN(minor1) || isNaN(major2) || isNaN(minor2)) {
      return false;
    }

    return major1 === major2 && minor1 === minor2;
  }, []);

  useEffect(() => {
    if (backendVersion && frontendVersion) {
      setDisplayAlert(
        !compareVersions(backendVersion?.version, frontendVersion)
      );
    } else {
      setDisplayAlert(false);
    }
  }, [backendVersion, frontendVersion, compareVersions, profile]);

  return (
    <>
      {displayAlert && (
        <Alert
          variant="filled"
          severity="warning"
          action={
            <Button color="inherit" size="small" onClick={() => navigate(0)}>
              OK
            </Button>
          }
        >
          Votre version de Pandora {frontendVersion} n&apos;est pas à jour.
          Veuillez rafraichir la page pour passer en {backendVersion?.version}.
        </Alert>
      )}
    </>
  );
};

export default CheckVersion;
